var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Container',[_c('b-tabs',{attrs:{"expanded":""}},[_c('b-tab-item',{attrs:{"label":"Students","icon":"users"}},[_c('student-display',{attrs:{"hasAction":false}})],1),_c('b-tab-item',{attrs:{"label":"Bus","icon":"bus"}},[_c('BusDisplay',{attrs:{"hasAction":false}})],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }